import { render, staticRenderFns } from "./Activitys.vue?vue&type=template&id=48085b10&scoped=true"
import script from "./Activitys.vue?vue&type=script&lang=js"
export * from "./Activitys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48085b10",
  null
  
)

export default component.exports